import React from "react";
import ReactDOM from "react-dom";

import "./index.css";

import Alert from "./components/Alert";

import LIRGala from "./lirgala";
import Donate from "./donate";

/* uncomment for testing locally
window.lifeformsSettings = {
	id: "lirgala", // lirgala, donate
};*/

/* To close LIR Gala, replace <LIRGala /> with 
	<div style={{ paddingTop: "25px", paddingBottom: "25px" }}>
		<Alert
			data={{
				type: "notice",
				text: "Tickets to the 2027 Lady in Red Gala are now sold out.",
			}}
		/>
	</div> 

		Tickets for the 2027 Gala will be available for purchase later this year.
		
		hack for temp tickets back open by phone
		<p
			style={{
				marginTop: "25px",
				textAlign: "center",
				fontSize: "20px",
			}}
		>
			<span>
				Please visit our{" "}
				<a href="https://www.life-edu.org/donate/">donation page</a>{" "}
				to make a donation. To learn more about LIFE call 561.582.8083
				or email{" "}
				<a href="mailto:life@life-edu.org">life@life-edu.org</a>.
			</span>
		</p>
*/

const target = document.getElementById("lifeforms-root");
if (target) {
	if (!window.lifeformsSettings) {
		ReactDOM.render(
			<React.StrictMode>
				<Alert data={{ type: "error", text: "An error has occurred." }} />
			</React.StrictMode>,
			target,
		);
	} else {
		const { id } = window.lifeformsSettings;

		ReactDOM.render(
			<React.StrictMode>
				{id === "lirgala" || !id ? (
					<LIRGala />
				) : id === "donate" ? (
					<Donate />
				) : (
					<Alert data={{ type: "notice", text: "Page under development." }} />
				)}
			</React.StrictMode>,
			target,
		);
	}
}
